import React, { Component } from 'react';
import AbstractKey from './AbstractKey.js';
import { connect } from "react-redux";
import Colors from 'Colors.js';
const colors = new Colors();

class Pad extends AbstractKey {
    constructor(props) {
        super(props);
    }

    onClickKey() {
        if (this.props.notClickable) {
            return;
        }
        console.log("on click value = ", this.props.value);
        // when the user clicks a key, we should select that track
        if (this.props.keyboardEngine.isMidiMapped(this.props.value)) {
            // if user is on detail view, clicking deletes the mapping,
            // if there is one
            console.log('it is mapped so unmapping!');
            this.props.keyboardEngine.deleteMidiMapping(this.props.value);
        } else {
            // otherwise it maps the current slice to that
            /*
            this.props.keyboardEngine.map(
                this.key, this.props.sequencerEngine.cursor.track, 0);
                */
        }
    }

    render() {
        let className = 'pad';
        if (this.props.triggering) {
            className += ' flashit';
        }
        if (this.props.mini) {
            className += ' mini';
        }

        return (
            <div
              onClick={() => this.onClickKey()}
              style={this.getStyle()}
              className={className}>
              {this.props.value}
            </div>);
    }
}

const mapStateToProps = (state, props) => {
    let padMapping = state.keyboard.padMappings[props.value];
    let trackTriggers = padMapping === undefined ? undefined :
        state.tracks.triggers[padMapping.trackNumber];
    let triggering = trackTriggers === undefined ? false :
        trackTriggers[padMapping.sliceNumber];
    return {
        triggering: triggering,
        keyMapping: padMapping,
    };
};


export default connect(mapStateToProps, null)(Pad);
